import { apiHelper } from "./api_helper";

export const giayToNopApi = {
    SelectByHocSinh: (ts_hocsinh_id) => apiHelper.get(`giay-to-nop/hoc-sinh/${ts_hocsinh_id}`),
    Upload: (
        { formFiles,
            ts_hocsinh_id,
            dm_loaigiayto_id
        }) => apiHelper.post(`giay-to-nop/upload/hoc-sinh/${ts_hocsinh_id}/giay-to/${dm_loaigiayto_id}`, formFiles),
    DeleteChiTiet: (id) => apiHelper.delete(`giay-to-nop/chi-tiet/${id}`),
    Inserts: (data) => apiHelper.post('giay-to-nop/insert-multiple', data),

}